module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-thumb.21ce89ff.webp";